import { Button, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'

interface SidebarNavAnnouncementStepProps {
  title: string
  body: string
  actionLabel: string
  onAction: () => void
  // Omitted on the final step, where "Got it" is the only way out.
  onDismiss?: () => void
}

export const SidebarNavAnnouncementStep = ({
  title,
  body,
  actionLabel,
  onAction,
  onDismiss,
}: SidebarNavAnnouncementStepProps) => (
  <>
    <Text
      variant={TypographyStyles.LABEL_SM}
      color={TextColors.EMPHASIS}
      className="block mb-1"
    >
      {title}
    </Text>
    <Text variant={TypographyStyles.BODY_XS} color={TextColors.DEFAULT}>
      {body}
    </Text>
    <div className="flex items-center gap-2 mt-3">
      <Button variant="primary" size="sm" onClick={onAction}>
        {actionLabel}
      </Button>
      {onDismiss && (
        <Button variant="ghost" size="sm" onClick={onDismiss}>
          Dismiss
        </Button>
      )}
    </div>
  </>
)
